import styled from "styled-components";

export const StyledDemoCard = styled.section<{ index: number }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  transform: translateY(30%);
  transition: all 0.5s ease-in;
  opacity: 0;
  &.appear {
    transform: translateY(0) !important;
    opacity: 1 !important;
  }
  @media (max-width: 1100px) {
    flex-direction: column;
    padding: 0 1.5rem 3rem 1.5rem;
  }

  div {
    width: 100%;
    display: flex;
    margin-bottom: 5rem;
    &.text-area {
      justify-content: ${({ index }) =>
        index % 2 !== 0 ? "flex-start" : "flex-end"};
      align-items: ${({ index }) =>
        index % 2 !== 0 ? "flex-start" : "flex-end"};
      flex-direction: column;
      margin-left: ${({ index }) => (index % 2 !== 0 ? "3rem" : "0")};
      margin-right: ${({ index }) => (index % 2 !== 0 ? "0" : "3rem")};
      order: ${({ index }) => index % 2};
      h1 {
        font-size: 34px;
        margin: 10px 0 5px 0;
      }
      span {
        font-size: 14px;
        text-align: ${({ index }) => (index % 2 !== 0 ? "left" : "right")};
        width: 80%;
      }
      @media (max-width: 1100px) {
        order: 1;
        margin: 0;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        h1 {
          font-size: 18px;
          margin: 10px 0 5px 0;
        }
        span {
          font-size: 14px;
          text-align: left;
          width: 100%;
        }
      }
    }
    &.visual-area {
      justify-content: ${({ index }) =>
        index % 2 !== 0 ? "flex-end" : "flex-start"};
      align-items: center;
      order: 1;
      img {
        border: 1px solid #e6e6e6;
        border-radius: 0px;
        cursor: pointer;

        @media (max-width: 1100px) {
          width: 100%;
        }
      }

      @media (max-width: 1100px) {
        order: 1;
        margin: 0;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
      }
    }
  }
`;
